import {
  addDependencies,
  andDependencies,
  ceilDependencies,
  create,
  divideDependencies,
  evaluateDependencies,
  floorDependencies,
  formatDependencies,
  maxDependencies,
  minDependencies,
  modDependencies,
  notDependencies,
  orDependencies,
  parseDependencies,
  roundDependencies,
  sqrtDependencies,
  sumDependencies,
} from 'mathjs';
import { ComputeMathDateFunctions } from './functions/ComputeMathDateFunctions';
import { ComputeMathListFunctions } from './functions/ComputeMathListFunctions';
import { ComputeMathLogicFunctions } from './functions/ComputeMathLogicFunctions';
import { ComputeMathOtherFunctions } from './functions/ComputeMathOtherFunctions';

export const ComputeMath = create(
  {
    addDependencies,
    divideDependencies,
    formatDependencies,
    parseDependencies,
    orDependencies,
    andDependencies,
    notDependencies,
    minDependencies,
    maxDependencies,
    sqrtDependencies,
    sumDependencies,
    floorDependencies,
    roundDependencies,
    ceilDependencies,
    evaluateDependencies,
    modDependencies,
  },
  {
    predictable: true,
  },
);

/**
 * Includiamo tutte le funzioni disponibili; se non definiscono `fn` vengono
 * usate solo per la documentazione.
 */
export const ComputeMathAllFunctions = [
  // Funzioni sulle liste
  ...ComputeMathListFunctions,
  // Funzioni logiche
  ...ComputeMathLogicFunctions,
  // Funzioni generiche
  ...ComputeMathOtherFunctions,
  // Funzioni sulle date
  ...ComputeMathDateFunctions,
];

// Importiamo tutte le funzioni personalizzate dentro `ComputeMath`
ComputeMath.import(
  ComputeMathAllFunctions.filter(f => f.fn != null).map(f => ({
    [f.name]: f.fn!(ComputeMath),
  })),
);

// Rimuoviamo le funzioni che non vogliamo esportare
ComputeMath.import(
  {
    import: function () {
      throw new Error('Function import is disabled');
    },
    createUnit: function () {
      throw new Error('Function createUnit is disabled');
    },
    // parse: function () {
    //   throw new Error('Function parse is disabled');
    // },
    simplify: function () {
      throw new Error('Function simplify is disabled');
    },
    derivative: function () {
      throw new Error('Function derivative is disabled');
    },
  },
  { override: true },
);
